var request = require("./request");
var qs = require("../question-sets/qs.json");
var config = require("./config");
var resolve = require("./resolve");

exports.Get = function(id, viewname, funderId) {
  var last = "";
  if (viewname) last = "?viewName=" + viewname;
  if (funderId && viewname) {
    last += "&funderId=" + funderId
  } else if(funderId) {
    last = "?funderId=" + funderId
  }
  return request.get(resolve(config.url(), "/applications/" + id + "/" + last)).promise();
};

exports.GetFromUserRef = function(userRef, viewName) {
  return request.get(resolve(config.url(), "/applications/byUserRef/" + userRef + "?viewName=" + viewName)).promise();
}

exports.GetApplicationHistory = function(id, type, orgainisationalId) {
  return request.get(resolve(config.url(), "/applications/" + id + '/history?type=' + type + '&orgainisationalId=' + orgainisationalId)).promise();
};

exports.GetApplicationsForDirectSubmission = function(funderId, schemeId) {
  return request.get(resolve(config.url(), "/applications/fordirectsubmission"), {
    funderId: funderId,
    schemeId: schemeId
  }).promise();
};
exports.SubmitApplicationDirect = function(applicationId, funderId, schemeId) {
  var body = {
    funderId: funderId,
    schemeId: schemeId
  };
  return request.post(resolve(config.url(), "/applications/" + applicationId + "/directsubmissions"), body).promise();
};
exports.GetQuestions = function(id, fromFunder) {
  return request.get(resolve(config.url(), "/applications/" + id + "/questions?fromFunder=" + fromFunder)).promise();
};
exports.GetQuestionSet = function(id) {
  return request.get(resolve(config.url(), "/applications/" + id + "/questionset")).promise();
};
exports.SaveApplication = function(id, application) {
  return request.post(resolve(config.url(), "/applications/" + id + "/update"), application).promise();
};
exports.GetApplications = function(filter, status) {

  filter = (filter === undefined || filter == null) ? "" : filter;

  var statusString = "";
  if(status){
    statusString = "&status=" + status;
  }


  return request.get(resolve(config.url(), "/applications?filter=" + filter + statusString)).promise();
};
exports.Begin = function(applicantId, projectTitle, seekingPublicFunding, seekingTrustFunding, specificTrustForFundingId, specificSchemeUnderTrustId) {
  var rqst = {
    applicantId: applicantId,
    projectTitle: projectTitle,
    seekingPublicFunding: seekingPublicFunding,
    seekingTrustFunding: seekingTrustFunding,
    specificTrustForFundingId: specificTrustForFundingId,
    specificSchemeUnderTrustId: specificSchemeUnderTrustId
  };
  return request.post(resolve(config.url(), "/applications"), rqst).promise();
};
exports.Update = function(id, body) {
  return request.put(resolve(config.url(), "/applications/" + id), body).promise();
};
exports.UpdateStep = function(id, stepId, body, notify) {
  return request.put(resolve(config.url(), "/applications/" + id + "/steps/" + stepId + "?notifyFunder=" + encodeURIComponent(notify || false)), body).promise();
};
exports.AdminGetApplications = function(projectTitleFilter, organisationNameFilter, onlyUnapproved, pageSize, pageNumber) {
  var qry = {
    viewName: "UserApplicationDetailsView",
    projectTitleFilter: projectTitleFilter,
    organisationNameFilter: organisationNameFilter,
    onlyUnapproved: onlyUnapproved,
    pageSize: pageSize,
    pageNumber: pageNumber
  };
  return request.get(resolve(config.url(), "/applications/admin/all"), qry).promise();

};

exports.UpdateStatus = function(id, body) {
  return request.post(resolve(config.url(), '/applications/' + id + '/status'), body).promise();
}

exports.Search = function(filter, status, radius, catIds, area, sort,  pageSize, pageNumber) {
  var qry = {
    filter: filter,
    status: status,
    radius: radius,
    categories: catIds,
    area: area,
    sort: sort,
    pageSize: pageSize,
    pageNumber: pageNumber
  };
  return request.get(resolve(config.url(), "/applications/search"), qry).promise();
};
exports.SubmitDonation = function(donation) {
  return request.post(resolve(config.url(), "/applications/donations"), donation).promise();
};
exports.GetDonations = function(id, fundraiserId, view, pageSize) {
  return request.get(resolve(config.url(), "/applications/" + id + "/donations?view=" + view + "&fundraiserId=" + fundraiserId + "&pageSize=" + pageSize), fundraiserId).promise();
};
exports.GetComments = function(id, view) {
  return request.get(result(config.url(), "/applications/" + id + "/comments")).promise();
};

exports.UpdateApplicationSummary = function(id, rqst) {
  return request.put(resolve(config.url(), "/applications/" + id + "/projectsummary"), rqst).promise();
};
exports.UpdateApplicationDetails = function(id, rqst) {
  return request.put(resolve(config.url(), "/applications/" + id + "/projectdetails"), rqst).promise();
};
exports.CreateComment = function(applicationId, applicationComment) {
  return request.post(resolve(config.url(), "/applications/" + applicationId + "/comments"), applicationComment).promise();
};

exports.UpdateComment = function(applicationId, commentId, applicationComment) {
  var url = resolve(config.url(), "/applications/" + applicationId + "/comments/" + commentId);
  return request.put(url, applicationComment).promise();
};

exports.AddEvent = function(applicationId, event) {
  return request.post(resolve(config.url(), "/applications/" + applicationId + "/events"), event).promise();
};

exports.UpdateEvent = function(applicationId, eventId, event) {
  var url = resolve(config.url(), "/applications/" + applicationId + "/events/" + eventId);
  return request.put(url, event).promise();
};

exports.DeleteEvent = function(eventId) {
  return request.delete(resolve(config.url(), "/applications/events/" + eventId)).promise();  
};

exports.AdvancedSearch = function (query, viewName) {
  var urlFragment = "/applications/advancedsearch";
  if (viewName)
    urlFragment = urlFragment + "?viewName=" + viewName;
  return request.post(resolve(config.url(), urlFragment), query).promise();
};

exports.AddGalleryItem = function(applicationId, item) {
  return request.post(resolve(config.url(), "/applications/" + applicationId + "/galleryitems"), item).promise();
};

exports.UpdateGalleryItem = function(applicationId, itemId, item) {
  var url = resolve(config.url(), "/applications/" + applicationId + "/galleryitems/" + itemId);
  return request.put(url, item).promise();
};

exports.UpdateApplicationCoverPicture = function(applicationId, item) {
  var url = resolve(config.url(), "/applications/" + applicationId + "/coverPicture");
  return request.put(url, item).promise();
};

exports.UpdateApplicationCoverPictureUrl = function(applicationId, item) {
  var url = resolve(config.url(), "/applications/" + applicationId + "/coverPictureUrl");
  return request.put(url, item).promise();
};

exports.DeleteGalleryItem = function(applicationId, itemId) {
  var url = resolve(config.url(), "/applications/" + applicationId + "/galleryitems/" + itemId);
  return request.del(url).promise();
};

exports.GetFundingOffers = function(applicationId, viewName, pageSize, pageNumber) {
  var qry = {
    viewName: viewName,
    pageSize: pageSize,
    pageNumber: pageNumber
  };
  return request.get(resolve(config.url(), "/applications/" + applicationId + "/fundingoffers"), qry).promise();
};
exports.AcceptFundingOffer = function(offerId, termsInPost, termsUploaded, termsDocBlobId, termsDocFileName, termsDocFileSize, noTermsRequired) {
  return request.post(resolve(config.url(), "/applications/fundingoffers/" + offerId + "/accept"), {
    signedTermsAndConditionsInPost: termsInPost,
    signedTermsAndConditionsProvided: termsUploaded,
    signedTermsAndConditionsDocument: {
      blobId: termsDocBlobId,
      fileName: termsDocFileName,
      fileSize: termsDocFileSize,
    },
    noTermsRequired: noTermsRequired
  }).promise();
};
exports.RejectFundingOffer = function(offerId, rejectReason) {
  return request.post(resolve(config.url(), "/applications/fundingoffers/" + offerId + "/reject"), { rejectReason: rejectReason }).promise();
};

exports.GetApplicationStatsOverview = function(id) {
  return request.get(resolve(config.url(), "/applications/" + id + "/statsoverview")).promise();
}
exports.GetApplicationStats = function(id) {
  return request.get(resolve(config.url(), "/applications/" + id + "/stats")).promise();
}

exports.GetApplicationNotes = function(id, type, organisationId) {
  return request.get(resolve(config.url(), "/applications/" + id + "/notes?type=" + type +"&organisationId=" + organisationId)).promise();
}
exports.CreateApplicationNote = function(id, rqst) {
  return request.post(resolve(config.url(), "/applications/" + id + "/notes"), rqst).promise();
}
exports.UpdateApplicationNote = function(id, rqst) {
  return request.put(resolve(config.url(), "/applications/" + id + "/notes"), rqst).promise();
}
exports.RemoveApplicationNote = function(id, noteId) {
  return request.delete(resolve(config.url(), "/applications/" + id + "/notes?noteId=" + noteId)).promise();
}
exports.ResetToDraft = function(id, reason) {
  return request.put(resolve(config.url(), "/applications/" + id + "/resetToDraft"), { reason: reason }).promise();
}
exports.RequestEdit = function(id, reason){
  return request.put(resolve(config.url(), "/applications/" + id + "/requestEdit"), { reason: reason }).promise();
}
exports.GetRaisedFunds = function(id) {
  return request.get(resolve(config.url(), "/applications/" + id + "/raised-funds")).promise();
}
exports.CreateRaisedFundItem = function(id, body) {
  return request.post(resolve(config.url(), "/applications/" + id + "/raised-funds"), body).promise();
}
exports.UpdateRaisedFundItem = function(id, body) {
  return request.put(resolve(config.url(), "/applications/" + id + "/raised-funds/" + body.id), body).promise();
}
exports.RemoveRaisedFundItem = function (id, itemId) {
  return request.del(resolve(config.url(), "/applications/" + id + "/raised-funds/" + itemId)).promise();
}
exports.GetFeatured = function(){
  return request.get(resolve(config.url(), "/applications/featured")).promise();
}
exports.GetGeneralDocuments = function(applicationId, fromFunder){
  return request.get(resolve(config.url(), "/applications/" + applicationId + "/documents/questions?fromFunder=" + fromFunder)).promise();
}
exports.GetGrantOffers = function(id, view) {
  return request.get(resolve(config.url(), "/applications/" + id + "/grantOffers?view=" + view)).promise();
};
exports.GetMatchOffers = function(id, view) {
  return request.get(resolve(config.url(), "/applications/" + id + "/matchOffers?view=" + view)).promise();
};
exports.PostAdditionalQuestionSet = function(id, funderId, sourceType, sourceId, message) {
  return request.post(resolve(config.url(), "/applications/" + id + "/additionalquestionsets?funderId=" + encodeURIComponent(funderId)),
  {
    source: sourceType,
    id: sourceId,
    message: message ? message : null // convert empty string to null
  }).promise();
};
exports.SetStatus = function(id, req) {
  return request.post(resolve(config.url(), "/applications/" + id + "/status"), req).promise();
}
exports.AddSupportingDocument = function(doc){
  return request.post(resolve(config.url(), "/applications/" + doc.applicationId + "/documents/supportingdocument"), doc).promise();
}
exports.GetSupportingDocuments = function(applicationId){
  return request.get(resolve(config.url(), "/applications/" + applicationId + "/documents/supportingdocument")).promise();
}
exports.RemoveSupportingDocument = function(applicationId, documentId){
  return request.del(resolve(config.url(), "/applications/" + applicationId + "/documents/supportingdocument/" + documentId)).promise();
}

exports.GetLatestQuestionHistoryForFunder = function (id) {
  return request.get(resolve(config.url(), '/applications/' + id +'/questions/history/funderview/latest')).promise();
}

exports.CheckCurrentFundingRequirements = function (id) {
  return request.get(resolve(config.url(), '/applications/' + id +'/remainingtoraise')).promise();
}
